import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { CommonDataService } from '../../../../common/services/common-data.service';
import { GraphqlService } from '../../../../common/services/graphql.service';
import { HttpcallService } from '../../../../common/services/httpcall.service';
import { OpenLinkById } from '../../../../common/services/openlinkbyid';
import scrollIntoView from 'scroll-into-view-if-needed'

@Component({
  selector: 'app-xbrl-content',
  templateUrl: './xbrl-content.component.html',
  styleUrls: ['./xbrl-content.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // Enable OnPush for better performance
})
export class XbrlContentComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Input() crumbData: any = [];
  @Input() header: string = "";
  @Input() UserInfo;
  @Input() pageNums: string = "";
  @Input() isShowAllInOne: string = "false";
  contacts: any = [];

  @Output() myEvent = new EventEmitter<string>();
  @Input() hasSecContent: boolean;
  @Input() ContentPath: any;
  @Input() ShowSecContent: boolean;
  @Input() topicBodyContent: any = [];
  @Input() topicBodyContentSec: any = [];
  @Input() NormalXbrlContent: any = [];
  @Input() SECXbrlContent: any = [];
  @Input() HasSecXBRL: boolean = false;
  @Input() HasXBRL: boolean = false;
  @Input() TaxonomyUrl;
  secContent: any;

  apiResponse: any;
  element: string = "";
  backPathText: string = "";
  backPathLink: string = "";

  constructor(
    private graphQLService: GraphqlService,
    private commonDataService: CommonDataService,
    private router: Router,
    private httpCallService: HttpcallService,
    private openLink: OpenLinkById,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {
    // Setup debounced scroll check observable
    this.scrollCheck$.pipe(
      debounceTime(100),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.performScrollCheck();
    });
  }

  // TrackBy functions for *ngFor performance optimization
  trackByElementName(index: number, item: any): string {
    return item?.elementName || index;
  }

  trackByReference(index: number, item: any): string {
    return item?.topic && item?.subtopic && item?.paragraphNum ? `${item.topic}-${item.subtopic}-${item.paragraphNum}` : index.toString();
  }

  trackByInfo(index: number, item: any): string {
    return item?.contentPageTitle || index;
  }

  // Memoized sorting to avoid re-sorting on every change detection
  private sortedNormalXbrl: any[] = [];
  private sortedSECXbrl: any[] = [];
  private lastNormalXbrlInput: any[] = [];
  private lastSECXbrlInput: any[] = [];

  // Lifecycle management with RxJS
  private destroy$ = new Subject<void>();
  private scrollCheck$ = new Subject<void>();

  @HostListener('window:click', ['$event'])
  onClick(e: any) {
    const path = e.composedPath() as Array<any>;
    e.preventDefault();
    const firstAnchor = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xbrl");
    if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      this.myEvent.emit();
    }
  }

  // Optimized localStorage helper methods for batched access
  private getLocalStorageItems(keys: string[]): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    keys.forEach(key => {
      result[key] = localStorage.getItem(key);
    });
    return result;
  }

  private setLocalStorageItems(items: { [key: string]: string }): void {
    Object.entries(items).forEach(([key, value]) => {
      if (value) {
        localStorage.setItem(key, value);
      } else {
        localStorage.removeItem(key);
      }
    });
  }

  // Extract scroll check logic for better performance and readability
  private performScrollCheck(): void {
    this.elementNameXBRL = localStorage.getItem("xbrlElementName");
    if (!this.elementNameXBRL) return;

    const element = document.getElementById(this.elementNameXBRL?.trim());
    if (!element) return;

    // Batch DOM operations
    scrollIntoView(element, {
      scrollMode: 'always',
      block: 'start',
      inline: 'start',
      boundary: document.getElementsByTagName('app-main-content')[0]
    });

    // Check scroll position after initial scroll
    const rect = element.getBoundingClientRect();
    const appMainContent = document.getElementsByTagName('app-main-content')[0];
    const documentHeight = appMainContent ? appMainContent.scrollHeight : 0;
    const viewPortHeight = window.innerHeight;
    const top1Percent = viewPortHeight * 0.01;
    const scrollTop = window.scrollY || (appMainContent ? appMainContent.scrollTop : 0);
    const maxScrollTop = documentHeight - viewPortHeight;

    if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
      element.scrollIntoView(false);
      localStorage.removeItem("xbrlElementName");
    }
  }

  private handleSecContentNavigation(): void {
    // Batch localStorage operations
    const items = this.getLocalStorageItems(["DefaultSecView", "SecClicked"]);

    if (items["DefaultSecView"] === "false") {
      this.ShowSecContent = false;
    } else {
      this.ShowSecContent = true;
    }

    const secPageClicked = items["SecClicked"];
    if (!(secPageClicked === "undefined" || secPageClicked === null)) {
      const secID = document.getElementById(secPageClicked);
      if (secID) {
        scrollIntoView(secID, {
          scrollMode: 'always',
          block: 'start',
          inline: 'start',
          boundary: document.getElementsByTagName('app-main-content')[0]
        });
        // Clear after a short delay
        setTimeout(() => localStorage.removeItem("SecClicked"), 1000);
      }
    }
  }
  parameter: string[] = [];
  event$;
  elementNameXBRL;
  xbrl: any;
  publicationId: string = "";
  linkedElement: string = "";
  formattedXBRLFlag: boolean = false;
  ngOnInit() {
    this.publicationId = localStorage.getItem("publicationId");
    /*this.graphQLService.getGlobalLabels().subscribe(data => { this.getGlossaryLabel(data); });*/
    if (localStorage.getItem("xbrlReturnPathText") != null) {
      this.backPathText = localStorage.getItem("xbrlReturnPathText");
      this.backPathLink = localStorage.getItem("xbrlReturnPathLink");
    }
    if (this.router.url.split("/")?.length == 4) {
      this.linkedElement = this.router.url.split("/")[3];
      localStorage.setItem("xbrlElementName", this.linkedElement);
    }
    if (!this.formattedXBRLFlag) {
      // Use requestIdleCallback for non-critical sorting to improve perceived performance
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => {
          this.FormatXBRL();
          this.cdr.markForCheck(); // Manually trigger change detection after async operation
        });
      } else {
        // Fallback to setTimeout with 0ms delay
        setTimeout(() => {
          this.FormatXBRL();
          this.cdr.markForCheck();
        }, 0);
      }
    }
  }

  // Optimized sorting function with memoization
  private sortXBRLLinks(links: any[]): any[] {
    if (!links || links.length === 0) return [];
    return links.sort((a, b) => this.compareXBRLLinks(a, b));
  }

  // Consolidated comparison logic
  private compareXBRLLinks(a: any, b: any): number {
    if (a.topic !== b.topic) return a.topic < b.topic ? -1 : 1;
    if (a.subtopic !== b.subtopic) return a.subtopic < b.subtopic ? -1 : 1;
    if (a.section !== b.section) return a.section < b.section ? -1 : 1;

    const aParagraphParts = a.paragraphNum.split("-");
    const bParagraphParts = b.paragraphNum.split("-");

    if (aParagraphParts[1] !== bParagraphParts[1]) {
      const aNum = parseInt(aParagraphParts[1].replace(/[A-Z]/g, ''));
      const bNum = parseInt(bParagraphParts[1].replace(/[A-Z]/g, ''));
      if (aNum !== bNum) return aNum < bNum ? -1 : 1;
      return aParagraphParts[1].replace(/[0-9]/g, '') < bParagraphParts[1].replace(/[0-9]/g, '') ? -1 : 1;
    }

    if (a.subParagraph !== b.subParagraph) {
      if (a.subParagraph === "" || b.subParagraph === "") {
        return (a.subParagraph < b.subParagraph) ? 1 : -1;
      }
      return (a.subParagraph < b.subParagraph) ? -1 : 1;
    }

    return a.refRoleKey < b.refRoleKey ? -1 : 1;
  }

  // Helper function to batch sort content and links
  private sortContentAndLinks(xbrlContent: any[]): void {
    if (!xbrlContent || xbrlContent.length === 0) return;

    // Sort main content by title once
    xbrlContent.sort((a, b) => {
      if (a.title > b.title) return 1;
      if (a.title < b.title) return -1;
      return 0;
    });

    // Sort links for all content in single iteration
    for (let i = 0; i < xbrlContent.length; i++) {
      if (xbrlContent[i].currentSubtopicLinks?.length > 0) {
        xbrlContent[i].currentSubtopicLinks = this.sortXBRLLinks(xbrlContent[i].currentSubtopicLinks);
      }
      if (xbrlContent[i].otherSubtopicLinks?.length > 0) {
        xbrlContent[i].otherSubtopicLinks = this.sortXBRLLinks(xbrlContent[i].otherSubtopicLinks);
      }
    }
  }

  FormatXBRL() {
    // Early returns to avoid unnecessary processing
    const hasNormalContent = this.NormalXbrlContent?.length > 0;
    const hasSECContent = this.SECXbrlContent?.length > 0;

    if (!hasNormalContent && !hasSECContent) {
      this.saveFormattedDataToCache();
      return;
    }

    // Use requestIdleCallback for non-blocking sort operation
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        if (hasNormalContent) {
          this.sortContentAndLinks(this.NormalXbrlContent);
        }
        if (hasSECContent) {
          this.sortContentAndLinks(this.SECXbrlContent);
        }
        this.saveFormattedDataToCache();
        this.cdr.markForCheck();
      });
    } else {
      // Fallback: perform synchronously if requestIdleCallback not available
      if (hasNormalContent) {
        this.sortContentAndLinks(this.NormalXbrlContent);
      }
      if (hasSECContent) {
        this.sortContentAndLinks(this.SECXbrlContent);
      }
      this.saveFormattedDataToCache();
      this.cdr.markForCheck();
    }
  }
  //ngAfterViewCheckedCounter: number=0;
  ngAfterViewChecked() {
    this.commonDataService.showLoader.next(false);

    // Use NgZone to run outside Angular's zone for performance-critical operations
    this.ngZone.runOutsideAngular(() => {
      // Debounce scroll checks to prevent excessive executions
      this.scrollCheck$.next();

      // Handle SEC content navigation with consolidated logic
      this.handleSecContentNavigation();
    });
  }

  onRightClick(event: any, nav: string) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref" && (!event.target.getAttribute('href').toLowerCase().includes("fasb.org"))) {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (ahref.includes("-")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + ahref);
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("xbrl")) {
      let navPath = nav.split("-");
      if (navPath[1] != "" && navPath[2] != "") {
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        url = url + "/" + nav;
        event.srcElement.setAttribute("href", "/" + url);
      }
      else {
        if (navPath[1] == "") { event.srcElement.setAttribute("href", navPath[0] + "/tableOfContent"); }
        else { event.srcElement.setAttribute("href", navPath[0] + "-" + navPath[1] + "/tableOfContent"); }
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "span" && event.srcElement.className.toLowerCase().includes("anchor-child")) {
      let anchorTag = event.srcElement.parentElement as HTMLAnchorElement;
      let navPath = nav.split("-");
      if (navPath[1] != "" && navPath[2] != "") {
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        url = url + "/" + nav;
        anchorTag.href = "/" + url;
      }
      else {
        if (navPath[1] == "") { anchorTag.href = navPath[0] + "/tableOfContent"; }
        else { anchorTag.href = navPath[0] + "-" + navPath[1] + "/tableOfContent"; }
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "img" && event.srcElement.className.toLowerCase().includes("whatsnew-image")) {
      let anchorTag = event.srcElement.parentElement.parentNode as HTMLAnchorElement;
      let navPath = nav.split("-");
      if (navPath[1] != "" && navPath[2] != "") {
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        url = url + "/" + nav;
        anchorTag.href = "/" + url;
      }
      else {
        if (navPath[1] == "") { anchorTag.href = navPath[0] + "/tableOfContent"; }
        else { anchorTag.href = navPath[0] + "-" + navPath[1] + "/tableOfContent"; }
      }
    }
    else {
      let otherSourceUrlParts = event.target.getAttribute('href').split("/");
      let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
      event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
    }
  }

  saveFormattedDataToCache() {
    let formattedXBRL = { "topic": this.topic, "subTopic": this.subtopic, "NormalXBRL": this.NormalXbrlContent, "SecXBRL": this.SECXbrlContent, "rawXBRL": null, "FormattedXBRLFlag": true };
    this.httpCallService.setXBRLSubTopic(formattedXBRL).toPromise().then(data => console.log(data));
  }

  ngOnDestroy() {
    // Batch localStorage cleanup
    this.setLocalStorageItems({
      'xbrlReturnPathText': null,
      'xbrlReturnPathLink': null
    });

    this.commonDataService.backToXBRLActive.next(false);
    this.backPathText = "";

    // Cleanup subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
  @Input() topic: string = "";
  @Input() subtopic: string = "";
  @Input() backTo: string = "";
  title: string = "";
  @Input() elementName: string = "";
  @Input() reference: string = "";
  @Input() referenceOther: string = "";

  //getGlossaryLabel(data) {
  //  if (data != "") {
  //    var labels = data.content.data.labels;
  //    labels = labels.filter(x => x.key.trim());
  //    this.backTo = labels.filter(x => x.key == "backTo_Label").map(y => y.value);
  //    this.elementName = labels.filter(x => x.key == "elementName_Label").map(y => y.value);
  //    this.reference = labels.filter(x => x.key == "referenceInThisSubtopic_Header").map(y => y.value);
  //    this.referenceOther = labels.filter(x => x.key == "referenceInOtherSubtopic_Header").map(y => y.value);
  //  }
  //}

  BackToContent() { localStorage.removeItem("xbrlReturnPathLink"); this.router.navigateByUrl(this.backPathLink); }

  //navigate(topicId: string, publicationId: string, para_num: string, pageInfoId: string, pageName: string) {
  //  localStorage.setItem("paragraphNum", para_num);
  //  this.route.navigateByUrl(publicationId + "/" + topicId + "/" + pageInfoId + "/" + pageName);
  //}

  //goToContent(reference: any, subtopicType: string) {
  //  //
  //  //this.route.navigateByUrl(publicationId + "/" + reference.topicId);
  //  let navPath: string = "";
  //  let paranum: string = "";
  //  if (subtopicType == 'current') {
  //    navPath = reference.topic + "-" + reference.subtopic + "-" + reference.section;
  //    paranum = reference.topic + "-" + reference.subtopic + "-" + reference.paragraphNum;
  //  }
  //  else {
  //    navPath = reference.topic.split(" ")[0] + "-" + reference.subtopic.split(" ")[0] + "-" + reference.paragraph.split(" ")[0];
  //    paranum = reference.topic.split(" ")[0] + "-" + reference.subtopic.split(" ")[0] + "-" + reference.paragraphNum;
  //  }
  //  this.graphQLService.getNavPathTree(navPath).subscribe(data => { this.router.navigateByUrl(data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + paranum) })
  //}

  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.target.getAttribute('href').toLowerCase().includes("fasb.org") && event.target.getAttribute('href').toLowerCase().includes("contentserver")) {
      event.srcElement.setAttribute("href", this.TaxonomyUrl);
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath?.length >= 3) {
        this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  redirectTo(navPath: string) {
    let navPathSplits = navPath.split("-");
    if (navPathSplits[1] != "" && navPathSplits[2] != "") {
      let url = this.getBreadcrumbWithNavPath(navPathSplits[0] + "-" + navPathSplits[1] + "-" + navPathSplits[2]);
      url = url + "/" + navPath;
      this.router.navigateByUrl(url);
    }
    else {
      if (navPathSplits[1] == "") { this.router.navigateByUrl(navPathSplits[0] + "/tableOfContent"); }
      else { this.router.navigateByUrl(navPathSplits[0] + "-" + navPathSplits[1] + "/tableOfContent"); }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 0; i < 9; i++) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j].itemData != null) {
            for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
              if (tempData[i].itemData[j].itemData[k].itemData != null) {
                for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                  if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                    navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                    return navPathUrl;
                  }
                  else {
                    if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                      for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                          navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                          return navPathUrl;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  openLinkById(event) {

    if (event.srcElement.tagName.toLowerCase() == "a" && event.target.getAttribute('href').toLowerCase().includes("fasb.org")) {
      let ahref = event.srcElement.innerText;
      if (!ahref.includes("-") && !ahref.includes("(") && !ahref.includes("[") && !ahref.includes("through")) {
        window.open(this.TaxonomyUrl, "_blank");
      }
    }
    else {
      this.openLink.linkClicked(event);
    }

  }
}
